export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung eines elektronischen Schecks"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einlagenkonto"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nummer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierungscode"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überprüfen"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aktivieren Sie"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elektronischen Scheck aktivieren"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betrag"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiv"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Storniert"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wird aktiviert"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rückgabe"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausstehend"])}
  }
}